import React, { useEffect, useState } from 'react'
import AdjustmentSkeleton from '../../../../../../../adjustments/containers/AdjustmentsList/components/AdjustmentSkeleton'

const FRONT_URL = process.env.REACT_APP_FRONT_URL || 'https://next.stg.getplika.com'

const LoadInterface = ({ periodId, forecastId, step, onSaved }) => {
  const [loadingIframe, setLoadingIframe] = useState(true)

  useEffect(() => {
    // the grid tells us it saved, so the other tabs and the KPIs reload
    const handleMessage = (event) => {
      if (event.data?.type === 'LOAD_INTERFACE_SAVED' && onSaved) {
        onSaved()
      }
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [onSaved])

  return (
    <div style={{ width: '100%', height: window.innerHeight - 170 }}>
      {loadingIframe && <AdjustmentSkeleton />}
      <iframe
        id="LoadInterface"
        title="LoadInterface"
        src={`${FRONT_URL}/iframe/forecast/${periodId}/${forecastId}/${step}/load-interface`}
        width="100%"
        height="100%"
        style={{
          border: 'none',
          padding: '0 0',
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
        onLoad={() => setLoadingIframe(false)}
      ></iframe>
    </div>
  )
}

export default LoadInterface
